import { useState } from 'react';

const useCard = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  return { showOverlay, setShowOverlay };
};

export default useCard;
